<template>
  <div class="container">
    <img class="banner img-fluid"
         src="/wp-content/uploads/2021/08/op-banner-scaled-1.png"
         alt="Online Payments">
    <p>Please note that credit card payments via installment are limited to the settlement of membership fees. If credit
      card via installment is used to settle amounts due that are not membership fees, iCare reserves the
      right to cancel and reverse the transaction. Charges by the card issuer relating to the cancellation of the
      transaction will be shouldered by the cardholder.</p>

    <ul class="steps">
      <li><span class="step-label">Step 1</span> Select the option of your choice.</li>
      <li><span class="step-label">Step 2</span> Proceed with your payment.</li>
      <li><span class="step-label">Step 3</span> iCare will send your official receipt to the email used in
        the card transaction.
      </li>
    </ul>

    <p>For any concerns, instructions and if you want to share the confirmation page of your payment, please
      email <a href="mailto:cashier@insularhealthcare.com.ph"><em>cashier@insularhealthcare.com.ph</em></a>. Please note that your payment will be verified and once validated, it will
      be officially acknowledged by the issuance of an <em>Official Receipt</em>.
    </p>

    <div class="row mt-4 payment-type-selection">
      <div class="col-sm-6 col-xs-12">
        <h5 class="payment-type-title">ONE-TIME PAYMENT</h5>
        <div v-for="(payment, index) in onetimePaymentTypes" :key="index"
             class="custom-control custom-radio payment-type">
          <input type="radio" :id="'otPaymentType' + index" name="paymentType" class="custom-control-input"
                 :value="payment" v-model="selectedPayment">
          <label class="custom-control-label" :for="'otPaymentType' + index">{{ payment.title }}
            <img class="img-fluid label-img" :src="payment.logo" :alt="payment.title">
          </label>
        </div>
      </div>
      <div class="col-sm-6 col-xs-12">
        <h5 class="payment-type-title">INSTALLMENT</h5>
        <div v-for="(payment, index) in installmentPaymentTypes" :key="index"
             class="custom-control custom-radio payment-type">
          <input type="radio" :id="'itPaymentType' + index" name="paymentType" class="custom-control-input"
                 :value="payment" v-model="selectedPayment">
          <label class="custom-control-label" :for="'itPaymentType' + index">{{ payment.title }}
            <img :class="[payment.type === 'security_installment' || payment.type === 'aub_installment' ? 'custom-paylater-logo img-fluid label-img' : 'img-fluid label-img']" :src="payment.logo" :alt="payment.title">
          </label>
        </div>
      </div>
    </div>
    <payment-form v-if="selectedPayment !== null" :payment="selectedPayment"></payment-form>
  </div>
</template>

<script>

import PaymentForm from "./components/PaymentForm";

export default {
  name: 'App',
  components: {
    PaymentForm
  },
  data() {
    return {
      onetimePaymentTypes: [
        {
          type: 'credit_card',
          title: 'Straight Card',
          logo: '/wp-content/uploads/2021/08/visamasterjcb.png',
          payments_for: ['InHealth Persona', 'Privilege Care', 'Availment outside HMO coverage', 'InHealth Biz']
        },
        /*{
          type: 'bpi_online_banking',
          title: 'BPI Online Banking',
          logo: 'https://www.insularhealthcare.com.ph/wp-content/uploads/2021/04/bpi-logo.png',
          payments_for: ['InHealth Persona', 'Privilege Care', 'Availment outside HMO coverage']
        }*/
        /*{
          type: 'amex',
          title: 'Straight Card',
          logo: 'https://www.insularhealthcare.com.ph/wp-content/uploads/2021/08/American_Express_logo_sml.jpg',
          payments_for: ['InHealth Persona', 'Privilege Care', 'Availment outside HMO coverage', 'InHealth Biz']
        }*/
      ],
      installmentPaymentTypes: [
        {
          type: 'aub_installment',
          title: 'AUB Installment',
          logo: '/wp-content/uploads/2022/11/new-aub-paylater-logo.png',
          payments_for: ['InHealth Persona', 'Privilege Care'],
          terms: [3, 6, 12]
        },
        // {
        //   type: 'bdo_installment',
        //   title: 'BDO Buy Now, Pay Later',
        //   logo: 'https://www.insularhealthcare.com.ph/wp-content/uploads/2021/04/bdo-logo.png',
        //   payments_for: ['InHealth Persona', 'Privilege Care'],
        //   terms: [3, 6]
        // },
        {
          type: 'bpi_installment',
          title: 'BPI Installment',
          logo: '/wp-content/uploads/2021/04/bpi-logo.png',
          payments_for: ['InHealth Persona', 'Privilege Care'],
          terms: [3, 6, 12]
        },

        // {
        //   type: 'paymongo_installment',
        //   title: 'Chinabank Installment',
        //   logo: 'https://www.insularhealthcare.com.ph/wp-content/uploads/2022/05/chinabank-logo.png',
        //   payments_for: ['InHealth Persona', 'Privilege Care'],
        //   terms: [3, 6]
        // },

        {
          type: 'security_installment',
          title: 'Security Bank Installment',
          logo: '/wp-content/uploads/2022/08/sbc-pay-later-logo.png',
          payments_for: ['InHealth Persona', 'Privilege Care'],
          terms: [3, 6, 12]
        }
      ],
      selectedPayment: null
    }
  }
}

</script>
<style scoped lang="scss">
.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #00979d;
  background-color: #00979d;
}

.custom-control-label {
  font-size: 1.1rem;
}

.payment-type {
  padding: 10px 15px;

}

.label-img {
  max-height: 40px;
  float: right;
  padding-left: 15px;
  margin-top: -15px;
}

.banner {
  margin-bottom: 20px;
}

p {
  text-align: justify
}

.steps {
  padding-left: 0;
}

.steps li {
  list-style: none;
}

.step-label, .payment-type-title {
  color: #00979d;
  font-weight: bold;
}

.payment-type-title {
  text-align: left;
  margin-bottom: 20px;
}

@media only screen and (max-width: 992px) {
  #payment > div > div > div:nth-child(1) > div:nth-child(2) > label > img {
    max-height: 40px !important;
    float: left !important;
    padding-left: 0 !important;
    margin-top: 0 !important;
    margin-left: -19px !important;
  }

  .label-img {
    float: none !important;
    padding-left: 0 !important;
    margin-top: 0 !important;
    display: block !important;
  }

  .payment-type-title {
    margin-bottom: 0 !important;
    margin-top: 30px !important;
  }

  .custom-paylater-logo {
    max-height: 25px;
    margin-top: 0px;
  }
}

</style>
